import React, { useMemo } from "react";
import PlanLayout from "./PlanLayout";
import { Button } from "@chakra-ui/react";
import { Icon } from "@iconify/react/dist/iconify.js";
import SingleCard from "../SiteFeasibility/SingleCard";
import Img2 from "../../../../../assets/Img2.png";
import {
  getMinioImage,
  getUpdatedImageUrlWithSize,
} from "../../../../../utils/helpers";
import MasonaryWrapper from "../../../../../components/MasonaryWrapper";
import { useFormContext } from "../FormStateContext";

/**
 * Groups all concept items by version chain.
 * Each group shares the same "root" _id (the original, non-versioned item).
 * Returns an array of { latest, allVersions } objects — one per unique group.
 */
function groupByVersionChain(items = []) {
  if (!items || items.length === 0) return [];

  // Build a map: id → item
  const byId = {};
  items.forEach((item) => {
    byId[item._id] = item;
  });

  // For each item, walk up parentVersionId to find the root id
  function getRootId(item) {
    let cur = item;
    while (cur?.parentVersionId && byId[cur.parentVersionId]) {
      cur = byId[cur.parentVersionId];
    }
    return cur._id;
  }

  // Group by root id
  const groups = {};
  items.forEach((item) => {
    const rootId = getRootId(item);
    if (!groups[rootId]) groups[rootId] = [];
    groups[rootId].push(item);
  });

  // For each group, sort by version desc and pick the latest
  return Object.values(groups).map((group) => {
    const sorted = [...group].sort(
      (a, b) => (b.version || 1) - (a.version || 1),
    );
    return { latest: sorted[0], allVersions: sorted };
  });
}

function ConcepMoodBoardForm({
  activeTab,
  data,
  setActiveTab,
  isRandom,
  fetchPresentationData,
  handlePublicLink,
  duplicatePresentation,
}) {
  console.log({ data });
  const { setTab } = useFormContext();

  // Group items, show only latest per version chain in the grid
  const groupedData = useMemo(() => groupByVersionChain(data), [data]);

  // Find allVersions for the currently edited item
  const editingVersionGroup = useMemo(() => {
    if (!activeTab.isEditId || !data) return [];
    // Find which group contains the editing id
    const groups = groupByVersionChain(data);
    const group = groups.find((g) =>
      g.allVersions.some((v) => v._id === activeTab.isEditId),
    );
    return group ? group.allVersions : [];
  }, [activeTab.isEditId, data]);

  return (
    <div className="w-full">
      {activeTab.index === 1 && activeTab.showForm ? (
        <PlanLayout
          isRandom={isRandom}
          handlePublicLink={handlePublicLink}
          setActiveTab={() =>
            setActiveTab((prev) => ({
              ...prev,
              isRender: !prev?.isRender,
            }))
          }
          data={data}
          isEdit={activeTab.isEditId}
          allVersions={editingVersionGroup}
          onVersionChange={(id) =>
            setActiveTab((prev) => ({ ...prev, isEditId: id }))
          }
          storeActiveTab={() => setTab(activeTab)}
        />
      ) : (
        <MasonaryWrapper>
          {groupedData.map(({ latest: item, allVersions }, index) => (
            <SingleCard
              duplicatePresentation={duplicatePresentation}
              images={[Img2, Img2, Img2, Img2]}
              randomImages={
                isRandom
                  ? item.areas
                      .map((v) => [
                        ...v.areaImage.map((i) =>
                          getUpdatedImageUrlWithSize(
                            getMinioImage(i, true),
                            [1, 1, 2],
                          ),
                        ),
                        ...v.internalImages,
                      ])
                      .flat() || []
                  : []
              }
              label={"Conceptual Mood Board"}
              key={`${item?._id}-${index}`}
              data={item}
              allVersions={allVersions}
              isRandom={isRandom}
              activeTabIdx={activeTab?.index}
              handlePublicLink={() =>
                handlePublicLink(`conceptual/${item?._id}/${item?.companyName}`)
              }
              fetchPresentationData={fetchPresentationData}
              handleEdit={(id) =>
                setActiveTab((p) => ({
                  ...p,
                  showForm: true,
                  index: 1,
                  isEditId: id,
                }))
              }
            />
          ))}
        </MasonaryWrapper>
      )}

      {/* <Button
        width={"100%"}
        type="button"
        className={
          "text-white bg-green-500 hover:bg-green-600 py-2 px-4 rounded-lg disabled:bg-slate-400 disabled:cursor-not-allowed "
        }
        colorScheme="teal"
        leftIcon={<Icon className="text-lg" icon="fluent:add-48-filled" />}
        variant={"outline"}
      >
        Create New Area Plan
      </Button> */}
    </div>
  );
}

export default ConcepMoodBoardForm;
